<template>
	<div class="box">
		<div class="ipt">
			<input type="text" name="" id="" value="" v-model="keyValue" placeholder="哪里不舒服或想了解牙科知识，请输入"/>
			<div class="btn" @click="get_wikisFn">
			</div>
		</div>
		<!--<div>
			<related></related>
		</div>-->
		<div class="content" v-if="contentBool">
			<div class="tab">
				<div>
					相关阅读
				</div>
				<div @click="get_wikisdateFn">
					<span>
						时间	
					</span>
					<img src="../assets/image/dateDown.png" alt="" v-if="sort==0"/>
					<img src="../assets/image/dateUp.png" alt="" v-if="sort==1"/>
				</div>
			</div>
			<div class="dataList">
				<div class="dataBox" v-for="item in dataList" @click="aherf(item.wUrl)">
					<div>
						<img :src="'https://api.bats-bio.com'+item.wTitleImg" alt="" />
					</div>
					<div>
						<span>{{item.wTitle}}</span>
						<p>{{item.wContent}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="souing" v-if="souingBool">
			<img src="../assets/image/ssing.png" alt="" />
			<p>搜索中...</p>
		</div>
		<div class="nocontent" v-if="nocontentBool">
			<img src="../assets/image/noContent.png" alt="" />
			<p>未搜索到内容</p>
		</div>
	</div>
</template>

<script>
import {get_wikis,keywords_types_list,keywords_row} from './http/api.js'
import related from '../component/relatedDiseases.vue'
export default{
	components:{
		related
	},
	data(){
		return{
			keyValue:'',
			sort:0,
			dataList:null,
			contentBool:true,
			souingBool:false,
			nocontentBool:false
		}
	},
	created(){
		this.routerget_wikisFn();
	},
	methods:{
		get_wikisFn(){
			this.souingBool=true;
			this.contentBool=false;
			this.nocontentBool=false;
			this.dataList=[];
			var data = {
				typeid:'1',
				key:this.keyValue,
				sort:this.sort,
				wno:this.$route.query.wno
			}
			get_wikis(data).then(res=>{
				if(res.result==1){
					if(res.data==""){
						this.nocontentBool=true;
						this.contentBool=false;
						this.souingBool=false;
					}else{
						this.dataList=res.data;
						this.souingBool=false;
						this.contentBool=true;
						this.nocontentBool=false;
					}
				}else{
					this.souingBool=true;
					
				}
			})
		},
		get_wikisdateFn(){
			if(this.sort==0){
				this.sort=1
			}else{
				this.sort=0
			}
			this.get_wikisFn()
		},
		aherf(url){
//			this.$router.push({
//				name:'iframe',
//				query:{
//					srcVal:'https://mp.weixin.qq.com/s/CBkr5YIhTyRfcEmS7QdcUw'
//				}
//			})
			window.location.href = url;
		},
		routerget_wikisFn(){
			this.keyValue=this.$route.query.val;
			this.souingBool=true;
			this.contentBool=false;
			this.nocontentBool=false;
			this.dataList=[];
			var data = {
				typeid:'1',
				key:this.$route.query.val,
				sort:this.sort,
				wno:this.$route.query.wno
			}
			get_wikis(data).then(res=>{
				if(res.result==1){
					if(res.data==""){
						this.nocontentBool=true;
						this.contentBool=false;
						this.souingBool=false;
					}else{
						this.dataList=res.data;
						this.souingBool=false;
						this.contentBool=true;
						this.nocontentBool=false;
					}
				}else{
					this.souingBool=true;
					
				}
			})
		},
	}
}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.ipt{
		margin-top: 10px;
		height: 90px;
		width: 100%;
		display: flex;
		justify-content: center;
		position: relative;
	}
	.ipt>input{
		width: 100%;
		height: 80px;
		margin: 0 30px;
		padding-left: 20px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 10px 5px rgba(245,245,245,0.4),0px 0px 2px 1px rgba(218,218,218,0.23);	
		border-radius:16px;
		border:1px solid rgba(151,151,151,.4);
		outline: none;
	}
	.btn{
		width:74px;
		height:74px;
		background:rgba(29,181,255,1);
		border-radius:14px;
		background: url(../assets/image/sousuo.png) no-repeat center center;
		position: absolute;
		top: 5px;
		right: 35px;
		background-size:100% ;
		
	}
	.content{
		margin: 0 50px;
		margin-top: 40px;
		overflow: hidden;
	}
	.content>.tab{
		overflow: hidden;
		border-bottom: 1px solid rgba(155,155,155,0.1);
	}
	.content>.tab>div{
		font-size:30px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:30px;
	}
	.content>.tab>div:nth-child(1){
		float: left;
		position: relative;
		color: rgba(29,181,255,1);
		height: 100%;
		padding-bottom:15px ;
	}
	.content>.tab>div:nth-child(1)::before{
		content: "";
		display:block;
		width:100%;
		height:5px;
		background:rgba(29,181,255,1);
		border-radius:4px 4px 0px 0px;
		position: absolute;
		bottom: 0;
	}
	.content>.tab>div:nth-child(2){
		float: right;
		display: flex;
	}
	.content>.tab>div>img{
		height: 30px;
		margin-left: 10px;
	}
	.souing,.nocontent{
		width: 100%;
		height: 100%;
		text-align: center;
		margin-top: 40px;
		/*border-top: 1px solid rgba(155,155,155,0.1) ;*/
	}
	.souing>img{
		width: 639px;
		margin-top: 150px;
	}
	.nocontent>img{
		width: 240px;
		margin-top: 260px;
	}
	.souing>p{
		font-size:28px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(74,74,74,1);
		line-height:30px;
		margin-top: 60px;
	}
	.nocontent>p{
		font-size:28px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(74,74,74,1);
		line-height:30px;
		margin-top: 100px;
	}
	.dataBox{
		height: 190px;
		overflow: hidden;
		display: flex;
		border-bottom:1px solid rgba(155,155,155,0.23) ;
	}
	.dataBox>div:nth-child(1){
		width:250px;
		height:140px;
		background:rgba(232,232,255,1);
		border-radius:3px;
		text-align: center;
		line-height: 140px;
		overflow: hidden;
		margin-right: 50px;
		margin-top: 25px;
	}
	.dataBox>div:nth-child(1)>img{
		width:250px;
	}
	.dataBox>div:nth-child(2){
		width:410px;
		margin-top: 25px;
	}
	.dataBox>div:nth-child(2)>span{
		display: block;
		font-size:28px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600;
		color:rgba(74,74,74,1);
		line-height:30px;
		margin-top: 10px;
	}
	.dataBox>div:nth-child(2)>p{
		font-size:24px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:30px;
		margin-top: 20px;
		
	}
</style>


// WEBPACK FOOTER //
// src/components/search.vue